// All image require() calls live here — components import from this map, never call require() directly.
// logoLight = black/dark text logo → use on light backgrounds (admin, most merchant screens)
// logoDark = white/light text logo → use on dark backgrounds (cashier scanner, success screens)

export const images = {
  logoDark: require('./assets/images/logo-dark.png'),
  logoLight: require('./assets/images/logo-light.png'),
  changePinSuccess: require('./assets/images/change-pin-success.png'),
  pairingSuccess: require('./assets/images/pairing-success.png'),
  errorState: require('./assets/images/error-state.png'),
} as const
